import Axios from "../../configs/axios.config";

export const createHelpCenterCategory = (data) => Axios.post(`help-center/categories`, data).then(response=>response.data.data);
export const updateHelpCenterCategory = (data, id) => Axios.put(`help-center/categories/${id}`, data).then(response=>response.data.data);
export const getHelpCenterCategoryList = (data) => Axios.get('help-center/categories', { params: data }).then(response=>response.data.data);
export const getHelpCenterCategoryDetail = (id) => Axios.get(`help-center/categories/${id}`).then(response=>response.data.data);
export const deleteHelpCenterCategory = (id) => Axios.delete(`help-center/categories/${id}`);



